import type {
  ChannelContent,
  ChannelEnabled,
  MessageOption,
  StatusNotificationConfig,
} from '@/api/Rover/notifications/roverNotifications.types';
import { type ApplicationFormStatusCatalogItem, buildSummariesFromStatusCatalog, staticStatusLabelFromKey } from './statusCatalog';

export {
  type ApplicationFormStatusCatalogItem,
  buildSummariesFromStatusCatalog,
  isStaticStatusKey,
  staticStatusKey,
  staticStatusLabelFromKey,
} from './statusCatalog';

export const defaultContentForStatusLabel = (label: string): ChannelContent => ({
  email: {
    subject: 'Update on your {{program_name}} application',
    body: `Dear {{applicant_name}},\n\nThe status of your {{program_name}} application is now: ${label}.\n\nThank you,\nCommunity Development`,
  },
  sms: { body: `{{program_name}}: your application status is now ${label}.` },
  onscreen: { title: `Status: ${label}`, body: `Your application status is now ${label}.` },
});

const defaultEnabled = (): ChannelEnabled => ({ email: true, sms: true, onscreen: true });

export function buildStaticStatusConfig(statusKey: string, catalog: ApplicationFormStatusCatalogItem[]): StatusNotificationConfig {
  const label = staticStatusLabelFromKey(statusKey, catalog);
  const defaults = defaultContentForStatusLabel(label);
  return {
    status: statusKey,
    statusLabel: label,
    source: 'default',
    enabled: defaultEnabled(),
    activeOptionCount: 0,
    content: structuredClone(defaults),
    defaults,
    optionsSelectionMode: 'multiple',
    optionsFormat: 'bullets',
    updatedAt: null,
    updatedBy: null,
  };
}

export function buildStaticBootstrap(catalog: ApplicationFormStatusCatalogItem[]) {
  const summaries = buildSummariesFromStatusCatalog(catalog);
  const first = summaries[0]?.status ?? null;
  const load = (statusKey: string) => ({
    config: buildStaticStatusConfig(statusKey, catalog),
    options: [] as MessageOption[],
  });
  return { summaries, first, load };
}
